import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { colorPalette } from 'shared/constants';
import styles from './case-detail.module.scss';

function ExpandableReason({ reason, lang }) {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, [reason]);

  if (!reason) return null;

  return (
    <>
      <p
        ref={textRef}
        className={`${styles.reasonText} ${!expanded ? styles.reasonCollapsed : ''}`}>
        {reason}
      </p>
      {isTruncated && (
        <button
          type="button"
          className={styles.showMoreButton}
          onClick={() => setExpanded(!expanded)}>
          {expanded ? lang.SHOW_LESS : lang.SHOW_MORE}
        </button>
      )}
    </>
  );
}

export function CaseComplianceColumn({ metrics, lang }) {
  if (!metrics?.length) {
    return (
      <div className={styles.column}>
        <div className={styles.columnHeader}>{lang.COMPLIANCE_HEADER}</div>
        <div className={styles.columnContent}>
          <p className={styles.empty}>{lang.NO_DATA}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.column}>
      <div className={styles.columnHeader}>{lang.COMPLIANCE_HEADER}</div>
      <div className={styles.columnContent}>
        {metrics.map(metric => {
          const isCompliant = metric.meetsGroupGoal;

          return (
            <div key={metric.metricId} className={styles.metricRow}>
              <div className={styles.metricTitle}>{metric.title}</div>
              <div className={styles.complianceStatus}>
                <FontAwesomeIcon
                  icon={isCompliant ? faCheckCircle : faTriangleExclamation}
                  color={isCompliant ? colorPalette.greenPositive : colorPalette.redNegative}
                />
                <span
                  className={styles.complianceText}
                  style={{
                    color: isCompliant ? colorPalette.greenPositive : colorPalette.redNegative,
                  }}>
                  {isCompliant ? lang.COMPLIANT : lang.NON_COMPLIANT}
                </span>
              </div>
              {!isCompliant && metric.reason && (
                <ExpandableReason reason={metric.reason} lang={lang} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
